
const ReserveRequest = {
  "searchKey": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  "gdsRefrenceID": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  "travelerInfo": {
    "phoneNumber": "string",
    "email": "string",
    "railTravelers": [
      {
        "dateOfBirth": "string",
        "gender": 0,
        "passengerType": 1,
        "nationalId": "string",
        "nationality": "string",
        "passengerName": {
          "passengerFirstName": "string",
          "passengerMiddleName": "string",
          "passengerLastName": "string",
          "passengerTitle": 0
        },
        "passport": {
          "country": "string",
          "expiryDate": "string",
          "passportNumber": "string"
        },
        "services": [
          0
        ]
      }
    ]
  }
  };
 

  export default ReserveRequest;
  